import { precoVisualizacao, ehValorDeCusto } from '@/utils/precoVisualizacao';

// Presentation-only helpers: no changes to item models, quotes or fiscal totals.
export default {
  data() {
    return { cotacoesVisuais: {} };
  },
  computed: {
    tipoPedidoVisual() {
      const form = this.formInfoPedido || this.getFormData
        || this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const capa = this.getCapaPedido || form.dataCapaPedido || {};
      return this.tipoPedidoPrecoVisual || this.tipoPedidoId || capa.tipopedidoid || capa.tipoPedidoId
        || form.tipoPedidoCliente?.tipopedidoid || form.tipoPedido?.tipopedidoid
        || info.tipoPedidoCliente?.tipopedidoid || info.tipoPedido?.tipopedidoid || '';
    },
    valorDeCustoVisual() {
      return ehValorDeCusto(this.tipoPedidoVisual);
    },
    totalVisualItens() {
      return this.somaVisual(this.itensTabela || []);
    },
  },
  methods: {
    registrarCotacaoVisual(itemId, resposta) {
      if (itemId != null && resposta && !resposta._erro) {
        this.$set(this.cotacoesVisuais, String(itemId), resposta);
      }
    },
    precoUnitarioVisual(item = {}) {
      if (Array.isArray(item.itens) && item.itens.length) {
        const precos = item.itens.map(linha => this.precoUnitarioVisual(linha));
        return precos.every(preco => preco === precos[0]) ? precos[0] : null;
      }
      const id = item.itemId || item.item_id || item.CodItem;
      const resposta = this.cotacoesVisuais?.[String(id)]
        || this.cotacoesPrecoVisuais?.[String(id)] || null;
      return precoVisualizacao({
        item: {
          ...item,
          precoUnitario: item.precoUnitario ?? item.valorUnitario ?? item.PrecoUnitario,
          ...(item._currentCalculation || {}),
          ...(resposta?.precoTabelaErp != null ? { precoTabelaErp: resposta.precoTabelaErp } : {}),
        },
        resposta,
        tipoPedido: item.tipoPedidoId || item.tipopedidoid || this.tipoPedidoVisual,
        assessment: item.assessmentFlag === true,
      });
    },
    quantidadeVisual(item = {}) {
      return Number(item.pedidoItemQuantidade ?? item.quantidade ?? item.valor ?? item.Qtde ?? 0);
    },
    subtotalVisual(item = {}) {
      if (Array.isArray(item.itens)) return this.somaVisual(item.itens);
      const preco = this.precoUnitarioVisual(item);
      return preco == null ? null : preco * this.quantidadeVisual(item);
    },
    somaVisual(itens = []) {
      let total = 0;
      for (const item of itens) {
        const subtotal = this.subtotalVisual(item);
        if (subtotal == null) return null;
        total += subtotal;
      }
      return total;
    },
    dinheiroVisual(valor) {
      return valor == null || !Number.isFinite(Number(valor)) ? '—'
        : Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    rotuloUnitarioVisual(rotulo = 'Valor unitário') {
      return this.valorDeCustoVisual ? 'Valor de custo' : 'Valor';
    },
  },
};